export {
  Icon as default,
  IconName,
  type IconSvgProps,
} from '@packages/shared-ui/components';
